import { render } from "./ManagePortfolio.vue?vue&type=template&id=340ba0b4"
import script from "./ManagePortfolio.vue?vue&type=script&lang=js"
export * from "./ManagePortfolio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anderson/Developer/Landing-Page/CambiosItalo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__